import { createContext } from "react";
import { Operation } from "./types";

const OperationContext = createContext<{
  operationData: Operation;
  allowActions: boolean;
  updateOperation: (operationId: string, draft: Record<string, never>) => void;
}>({ allowActions: false } as {
  operationData: Operation;
  allowActions: boolean;
  updateOperation: (operationId: string, draft: Record<string, never>) => void;
});

export default OperationContext;
